document.addEventListener('DOMContentLoaded', function () {
  const quantitySelect = document.getElementById("product-quantity-select");
  const quantityInput = document.getElementById("product-quantity-input");
  const quantityInputWrapper = quantityInput?.closest('.form-field--qty-input');
  const quantitySelectWrapper = quantitySelect?.closest('.form-field--qty-select');
  const variantSelect = document.querySelector('select[data-variants]');
  let priceEl = document.querySelector('.product-pricing .money[data-price]');

  // Fallback if price element not found
  if (!priceEl) {
    priceEl = document.querySelector('[data-current-price-hidden] .money[data-price]');
  }

  // Pull default price from Shopify product data if no variants
  const productData = window.ShopifyAnalytics?.meta?.product;
  const defaultVariant = productData?.variants?.[0];
  const fallbackPrice = defaultVariant?.price ? defaultVariant.price / 100 : null;

  if ((!quantitySelect && !quantityInput) || !priceEl) return;

  function updatePrice() {
    let unitPrice;

    // Get price from selected variant if possible
    if (variantSelect) {
      const selectedOption = variantSelect.options[variantSelect.selectedIndex];
      unitPrice = parseFloat(selectedOption.dataset.price);
    }

    // If product has no variants or price not found, use fallback
    if (isNaN(unitPrice)) {
      unitPrice = fallbackPrice;
    }

    const isInputVisible = quantityInputWrapper && !quantityInputWrapper.classList.contains('hidden');
    const customQuantity = isInputVisible ? parseInt(quantityInput.value, 10) : NaN;
    const selectQuantity = !isInputVisible ? parseInt(quantitySelect?.value, 10) : NaN;

    const quantity = !isNaN(customQuantity) && customQuantity > 0
      ? customQuantity
      : (!isNaN(selectQuantity) && selectQuantity > 0 ? selectQuantity : 1);

    if (!isNaN(unitPrice)) {
      const totalPrice = unitPrice * quantity;
      priceEl.textContent = formatPrice(totalPrice);
    }
  }

  // Handle select change
  if (quantitySelect) {
    quantitySelect.addEventListener('change', function () {
      if (quantitySelect.value === '10+') {
        showInputField();
      }
      updatePrice();
    });
  }

  // Handle input change
  if (quantityInput) {
    quantityInput.addEventListener('input', updatePrice);

    // Reset if input is cleared or less than 10
    quantityInput.addEventListener('blur', function () {
      const inputVal = parseInt(quantityInput.value, 10);
      if (isNaN(inputVal) || inputVal < 10) {
        hideInputField();
        updatePrice();
      }
    });
  }

  // Handle variant change
  if (variantSelect) {
    variantSelect.addEventListener('change', updatePrice);
  }

  // If page loads with 10+ selected
  if (quantitySelect && quantitySelect.value === '10+') {
    showInputField();
  }

  updatePrice(); // Run once on page load

  // Show input field for custom quantity
  function showInputField() {
    quantitySelectWrapper?.classList.add('hidden');
    quantityInputWrapper?.classList.remove('hidden');
    quantityInput.focus();

    const inputVal = parseInt(quantityInput.value, 10);
    if (isNaN(inputVal) || inputVal < 10) {
      quantityInput.value = '10';
    }
  }

  // Hide input and go back to dropdown
  function hideInputField() {
    quantityInputWrapper?.classList.add('hidden');
    quantitySelectWrapper?.classList.remove('hidden');
    quantitySelect.value = '1'; // or any default
  }
});

function formatPrice(amount) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(amount);
}